"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Column_1 = require("./Column");

var IconNavigation =
/** @class */
function (_super) {
  __extends(IconNavigation, _super);

  function IconNavigation(props) {
    var _this = _super.call(this, props) || this;

    _this.onResize = function (viewportSize) {
      _this.setState({
        viewport: viewportSize
      });
    };

    _this.state = {
      viewport: utils_1.WindowEvents.getViewportSize()
    };
    return _this;
  }

  IconNavigation.prototype.componentDidMount = function () {
    utils_1.WindowEvents.addViewportCallback(this.onResize);
  };

  IconNavigation.prototype.componentWillUnmount = function () {
    utils_1.WindowEvents.removeViewportCallback(this.onResize);
  };

  IconNavigation.prototype.render = function () {
    var _a = this.props,
        children = _a.children,
        className = _a.className,
        id = _a.id;
    var isViewportMobile = ["xs", "sm", "md"].includes(this.state.viewport); // Filter out the children which should not be displayed in mobile

    var filteredChildren = React.Children.map(children, function (child) {
      if (child.props.showInMobile === false) return;
      return child;
    }); // Check if more than 2 children(different layout in xs, sm and md viewport)

    var iconNavigationClassName = isViewportMobile && React.Children.count(filteredChildren) > 2 || !isViewportMobile && React.Children.count(children) > 2 ? CSSPrefix_1.lsgPre + "footer-iconnavigation-threeormorecolumns" : CSSPrefix_1.lsgPre + "footer-iconnavigation-twoorlesscolumns";
    var iconNavigationProps = {
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "footer-iconnavigation", iconNavigationClassName, className]),
      id: id
    };
    return isViewportMobile ? React.createElement("div", __assign({}, iconNavigationProps), filteredChildren) : React.createElement("div", __assign({}, iconNavigationProps), children);
  };

  IconNavigation.Column = Column_1.Column;
  return IconNavigation;
}(React.Component);

exports.IconNavigation = IconNavigation;